import { render, staticRenderFns } from "./DescriptionModal.vue?vue&type=template&id=974c38e0"
import script from "./DescriptionModal.vue?vue&type=script&lang=js"
export * from "./DescriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports